var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"card-awards-section-grid"},_vm._l((_vm.awards),function(award,i){return _c('div',{key:i,staticClass:"card-awards-section-grid__item"},[_c(_setup.CardSectionAwardsItem,{attrs:{"award":award,"index":i},on:{"click":function($event){return _vm.$emit('item-click', i)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }